import { useState, useEffect } from 'react';
import { areWeTestingWithJest } from 'test/helpers/formik';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function useExitPrompt(bool: any, cb: VoidFunction) {
    const [showExitPrompt, setShowExitPrompt] = useState(bool);

    const trigger = (event: Event): any => {
        if (showExitPrompt) {
            cb();

            const e = event || window.event;
            e.preventDefault();
            if (e) {
                e.returnValue = false;
            }
            return '';
        }
        return event.returnValue;
    };

    window.onpopstate = function () {
        window.onbeforeunload = null;
        window.removeEventListener('beforeunload', trigger);
    };
    window.onload = function () {
        window.addEventListener('beforeunload', trigger);
    };

    useEffect(() => {
        window.addEventListener('beforeunload', trigger);

        return () => {
            if (areWeTestingWithJest() === false) {
                window.onbeforeunload = null;
            }
            window.removeEventListener('beforeunload', trigger);
        };
    }, [showExitPrompt]);

    return [showExitPrompt, setShowExitPrompt];
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useLeavePrompt(bool: any, cb: VoidFunction) {
    const [showLeavePrompt, setShowLeavePrompt] = useState(bool);

    const trigger = (event: Event): any => {
        if (showLeavePrompt) {
            cb();

            const e = event || window.event;
            e.preventDefault();
            if (e) {
                e.returnValue = false;
            }
            return '';
        }
        return event.returnValue;
    };

    useEffect(() => {
        if (showLeavePrompt) {
            window.addEventListener('beforeunload', trigger);
        } else {
            window.onbeforeunload = null;
            window.removeEventListener('beforeunload', trigger);
        }
        return () => {
            if (areWeTestingWithJest() === false) {
                window.onbeforeunload = null;
            }
            window.removeEventListener('beforeunload', trigger);
        };
    }, [showLeavePrompt]);

    return [showLeavePrompt, setShowLeavePrompt];
}
